export class DeadEndComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-appointments/src/components/dead_end/dead_end.html';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    text: '<',
    isActive: '<'
  };
}

angular.module('capability-ng-appointments').component('deadEnd', new DeadEndComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/dead_end/dead_end.ts